import React, { Suspense } from "react";

import { useModalContext } from "@/contexts/modal-context";
import { MediaGallery } from "@/features/ui/util/async-components";

import type { Attachment } from "@/schemas";

interface AttachmentThumbsProps {
  media: Attachment[];
  onClick?(): void;
  sensitive?: boolean;
}

const AttachmentThumbs = (props: AttachmentThumbsProps) => {
  const { media, onClick, sensitive } = props;
  const { openModal } = useModalContext();

  const renderLoading = () => <div className="h-[50px] bg-transparent" />;
  const onOpenMedia = (attachments: Attachment[], index: number) =>
    openModal("MEDIA", {
      media: attachments.map((attachment) => ({ attachment })),
      index,
    });

  return (
    <div className="relative">
      <Suspense fallback={renderLoading()}>
        <MediaGallery
          media={media}
          onOpenMedia={onOpenMedia}
          height={50}
          compact
          sensitive={sensitive}
          visible
        />
      </Suspense>

      {onClick && (
        <div
          className="absolute inset-0 size-full cursor-pointer"
          onClick={onClick}
        />
      )}
    </div>
  );
};

export default AttachmentThumbs;
